/**
 * PaginaNaoExiste.js
 *
 * Copiado de hay-hotspot/assets/reactweb/src/pages/PaginaNaoExiste.js (Fase 1.6) — 100%
 * genérico, sem mudanças.
 */
import React, { Component } from 'react';
import { withRouter } from 'hay-core-react';
import { createSearchParams, Navigate } from 'react-router';
import { UtilService } from 'hay-core-react';
import RotaService from '../service/RotasService';

const CHAVE_TENTATIVA = 'deepLinkTentativa';
const JANELA_TENTATIVA_MS = 5000;

class PaginaNaoExiste extends Component {
  render() {
    const caminho = '/' + (this.props.params['*'] || '');
    const destino = caminho + window.location.search;
    const conheceRota = Object.values(RotaService).some(
      (cfg) => caminho === cfg.rota || caminho.startsWith(cfg.rota + '/')
    );
    const auth = UtilService.getLocalStorage('auth');
    let tentativaAnterior = null;
    try {
      tentativaAnterior = JSON.parse(sessionStorage.getItem(CHAVE_TENTATIVA));
    } catch { /* formato antigo/inválido -> trata como nenhuma tentativa anterior */ }
    const jaTentouEsseDestino = tentativaAnterior?.destino === destino
      && (Date.now() - tentativaAnterior.timestamp) < JANELA_TENTATIVA_MS;

    if (auth?.token && conheceRota && !jaTentouEsseDestino) {
      sessionStorage.setItem(CHAVE_TENTATIVA, JSON.stringify({ destino, timestamp: Date.now() }));
      const search = '?' + createSearchParams({ destino }).toString();
      return <Navigate to={{ pathname: '/login', search }} replace />;
    }

    sessionStorage.removeItem(CHAVE_TENTATIVA);
    return <Navigate to={{ pathname: auth?.token ? '/dashboard' : '/login' }} replace />;
  }
}
export default withRouter(PaginaNaoExiste);
